import React, { useState } from 'react';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';
import styled from 'styled-components';

import Sidebar from '../Sidebar';
import SmartBottomNav from '../SmartBottomNav';
import MenuModal from '../MenuModal';
import Header from '../Header';

const AppContainer = styled.div`
  min-height: 100dvh;
  background-color: transparent;
  overflow-x: hidden;
  max-width: 100vw;
  width: 100%;
  padding-bottom: 80px;

  @media (min-width: 1024px) {
    padding-left: ${props => props.isSidebarOpen ? '280px' : '72px'};
    padding-bottom: 0; 
    transition: padding-left 0.3s ease;
  }
`;

const DesktopContentWrapper = styled.div`
  width: 100%;
  max-width: 100vw;
  margin: 0 auto;
  min-height: 100dvh;
  overflow-x: hidden;
  padding-bottom: 30px;
  padding-top: 65px; /* Mobile padding and desktop fixed header offset */
`;

const DashboardLayout = ({ mode }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const activeTab = location.pathname.split('/')[2] || 'home';
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [showMenu, setShowMenu] = useState(false);

  const handleNav = (tabId, state = {}) => navigate(`/${mode}/${tabId}`, { state });
  const handleLogout = () => navigate('/');

  React.useEffect(() => {
    window.scrollTo(0, 0);
    // Scroll inner containers to top 
    const scrollViews = document.querySelectorAll('.manager-scroll-view, .profile-scroll-view, .content-area');
    scrollViews.forEach((el) => {
      if (el && el.scrollTo) el.scrollTo(0, 0);
    });
  }, [location.pathname]);

  return (
    <AppContainer className="full-screen" isSidebarOpen={isSidebarOpen}>
      <Header showMenu={showMenu} setShowMenu={setShowMenu} onLogout={handleLogout} />

      <Sidebar
        mode={mode}
        activeTab={activeTab}
        onTabPress={handleNav}
        onLogout={handleLogout}
        isOpen={isSidebarOpen}
        toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
      />

      <DesktopContentWrapper className="content-area">
        {/* React Router Output */}
        <Outlet context={{ handleLogout, mode }} />
      </DesktopContentWrapper>

      <SmartBottomNav mode={mode} activeTab={activeTab} onTabPress={handleNav} />

      <MenuModal showMenu={showMenu} setShowMenu={setShowMenu} onLogout={handleLogout} />
    </AppContainer>
  );
};

export default DashboardLayout;
